<template>
  <div
    :style="{
      backgroundImage:
        'url(' + require('../../assets/images/1964-M.C.png') + ')'
    }"
    class="header"
  >
    <div class="w-container hero-container">
      <h1 class="name">Marin <br />Constantin</h1>
      <div class="years">{{ $t("marinConstantin.header.years") }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "MCHeader"
};
</script>

<style scoped>
.header {
  height: 82vh;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  flex-direction: column;
  -webkit-background-size: cover;
  background-position: 60% 65%;
  background-size: cover;
  color: white;
  background-color: #071f32;
}

.name {
  font-family: Roboto, sans-serif;
  font-size: 5.3em;
  line-height: 1.2em;
  text-transform: uppercase;
}

.years {
  display: inline-block;
  padding: 25px 33px;
  border: 3px solid #86766d;
  font-family: Roboto, sans-serif;
  font-size: 1.6em;
  font-weight: 300;
  letter-spacing: 1px;
}

.hero-container {
  width: 100%;
  padding: 0 15px;
}

@media (max-width: 476px) {
  .header {
    background-position: 65% 50%;
    flex-direction: column;
    justify-content: flex-end;
    padding-bottom: 5vh;
  }

  .name {
    font-size: 3em;
  }

  .years {
    font-size: 1.2em;
    padding: 12px;
  }
}
</style>
